<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h3 v-if="!form.id">ADD NEW TICKER SELLER</h3>
        <h3 v-else>UPDATE TICKER SELLER</h3>
      </div>
      <div class="form-modal-body">
        <b-field label="First name">
          <b-input v-model="form.first_name"></b-input>
        </b-field>

        <b-field label="Last name">
          <b-input v-model="form.last_name"></b-input>
        </b-field>

        <b-field label="Profile Image">
          <div class="input-widget">
            <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
              location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
              :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.profile_image"
              @onFileSelected="onImageSelected">
              <div class="image-upload-widget">Choose Image to upload</div>
            </upload-trigger>
          </div>
        </b-field>
        <b-field label="Phone">
          <b-input v-model="form.phone_number"></b-input>
        </b-field>
        <b-field label="Email(Optional)">
          <b-input v-model="form.email"></b-input>
        </b-field>
        <b-field label="Password" :message="form.id ? `Leave empty if you don't want to change password` : ``">
          <b-input v-model="form.password"></b-input>
        </b-field>
        <b-field label="Allowed Event">
          <b-select v-model="form.eventId" expanded>
            <option v-for="(item, index) in event_sessions" :key="index" :value="item.id">{{ item.title }}</option>
          </b-select>
        </b-field>
        <b-field label="Status">
          <b-select v-model="form.account_status" expanded>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </b-select>
        </b-field>
      </div>
      <div class="form-modal-footer">
        <b-button :loading="loading" @click="submitForm()" type="is-primary">SAVE</b-button>
        <div class="h-spacer"></div>
        <b-button @click="onCancel()" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    event_sessions: [],
    isModalActive: true,
    form: {
      id: null,
      first_name: "",
      last_name: "",
      profile_image: "",
      phone_number: "",
      email: "",
      password: "",
      eventId: null,
      account_status: "active",
    },
    loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAllEvents();
    if (vm.value) {
      vm.editItem(vm.value);
    } else {
      vm.addNew();
    }
  },
  methods: {
    getAllEvents() {
      let vm = this;
      vm.$store
        .dispatch("EVENTS_GET_ALL_EVENT")
        .then(response => {
          vm.event_sessions = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    editItem(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.first_name = item.first_name;
      vm.form.last_name = item.last_name;
      vm.form.profile_image = item.profile_image;
      vm.form.phone_number = item.phone;
      vm.form.email = item.email;
      vm.form.eventId = item.eventId;
      vm.form.account_status = item.status;
    },
    addNew() {
      let vm = this;
      vm.form = {
        id: null,
        first_name: "",
        last_name: "",
        profile_image: "",
        phone_number: "",
        email: "",
        password: "",
        eventId: null,
        account_status: "active",
      };
    },
    submitForm() {
      let vm = this;
      vm.loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("ADMIN_TICKET_SELLER_ADD_NEW", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$store
          .dispatch("ADMIN_TICKET_SELLER_UPDATE", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.profile_image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

.modal {
  @media (max-width: 500px) {
    padding: 0 !important;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>